
import { useSelector } from 'react-redux';

import { IDashboardReportState } from '@store/slices';
import { InputFilterType } from '@share/common-types';

import { DashboardReportTopBase } from '../dashboard-report-top-base';

import './style.scss';
import { IntlShape } from 'react-intl';

export function DashboardReportTopDestinations({ intl }: { intl: IntlShape }) {

  const { loading, dashBoardData } = useSelector((state: { dashboardReportsStore: IDashboardReportState }) => state.dashboardReportsStore);
    
  const topDestinationsHomes = dashBoardData?.topDestinationsHomes;

  return (
    <DashboardReportTopBase topList={topDestinationsHomes} loading={loading} header={[
      { key: 'destination', description: intl.formatMessage({ id: 'search.destinationLabel' }), width: 170, type: InputFilterType.Text, display: true },
      { key: 'numberOfRooms', description: intl.formatMessage({ id: '#rooms' }),width: 105, type: InputFilterType.IntegerNumber, display: true },
      { key: 'numberOfBookings', description: intl.formatMessage({ id: '#bookings' }),width: 120, type: InputFilterType.IntegerNumber, display: true },
      { key: 'saving', description: intl.formatMessage({ id: 'savings' }),width: 115, type: InputFilterType.Currency, display: true },
      { key: 'marketShare', description: intl.formatMessage({ id: 'marketShare' }),width: 130, type: InputFilterType.IntegerNumber, display: true },
      { key: 'grossAmount', description: intl.formatMessage({ id: 'gross.amount' }), width: 135, type: InputFilterType.Currency, display: true },
    ]} />
  );
}
